import React from 'react';
import '../App.css';

class Footer extends React.Component {
    render() {
        return (
            <footer>
                <p class="attribution">
                    Challenge by <a href="https://www.frontendmentor.io?ref=challenge" target="_blank" rel="noopener noreferrer">Frontend Mentor</a>.
                        Coded by <a href="https://github.com/melodymastache?tab=repositories">Melody Mastache</a>.
                    </p>
            </footer>
        );
    }

}

export default Footer;